var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.5 15.8824C1.5 15.0532 2.14404 14.2693 3.68911 13.6485C5.18041 13.0493 7.16864 12.7647 9 12.7647C10.8314 12.7647 12.8196 13.0493 14.3109 13.6485C15.856 14.2693 16.5 15.0532 16.5 15.8824V17C16.5 18.1046 15.6046 19 14.5 19H3.5C2.39543 19 1.5 18.1046 1.5 17V15.8824ZM12.8571 4.70588C12.8571 6.71897 11.1561 8.41177 9 8.41177C6.84386 8.41177 5.14286 6.71897 5.14286 4.70588C5.14286 2.69279 6.84386 1 9 1C11.1561 1 12.8571 2.6928 12.8571 4.70588Z",
    stroke: "#9397A6",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.5ab05f33a3a1750a2e4d36458a50c934.svg";
export { ForwardRef as ReactComponent };